import { Injectable, signal } from '@angular/core';
import { translations as enTranslations } from '../assets/i18n/en';
import { translations as thTranslations } from '../assets/i18n/th';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private translations = signal<Record<string, any>>({});
  
  currentLang = signal<string>(localStorage.getItem('preferred_lang') || 'th');

  init(): Promise<void> {
    this.loadTranslations(this.currentLang());
    // Return a resolved promise to satisfy the APP_INITIALIZER
    return Promise.resolve();
  }

  use(lang: string): void {
    this.loadTranslations(lang);
    localStorage.setItem('preferred_lang', lang);
    this.currentLang.set(lang);
  }

  private loadTranslations(lang: string): void {
    try {
      if (lang === 'th') {
        this.translations.set(thTranslations);
      } else {
        this.translations.set(enTranslations);
      }
    } catch (error) {
       console.error(`CRITICAL: Could not load statically imported translations for lang "${lang}".`, error);
       this.translations.set({}); // Set to empty to prevent further errors
    }
  }

  translate(key: string, interpolateParams?: Record<string, string | number>): string {
    if (!key) {
      return '';
    }
    const keys = key.split('.');
    let result: any = this.translations();

    for (const k of keys) {
      if (result && typeof result === 'object' && Object.prototype.hasOwnProperty.call(result, k)) {
        result = result[k];
      } else {
        return key; // Return the key itself if not found
      }
    }

    if (typeof result !== 'string') {
        return key; // Return key if the found value is not a string
    }

    let translatedString = result;

    if (interpolateParams) {
      for (const [paramKey, paramValue] of Object.entries(interpolateParams)) {
        translatedString = translatedString.replace(
          new RegExp(`{{${paramKey}}}`, 'g'),
          String(paramValue)
        );
      }
    }

    return translatedString;
  }
}